import { createAction, props } from '@ngrx/store';
import { ClubManagement, CommunicationCategory, CommunicationFile, CommunicationStatus } from './club-management.model';


// fetch 
export const fetchclubManagementListData = createAction('[Data] fetch clubManagementList');
export const fetchclubManagementListSuccess = createAction('[Data] fetch clubManagementList success', props<{ ClubManagementListdata: ClubManagement[] }>())
export const fetchclubManagementListFail = createAction('[Data fetch clubManagementList failed]', props<{ error: string }>())

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records club management',
    props<{id: number}>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records club management success', 
    props<{ listData: ClubManagement[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records club management failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record club management',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record club management success', 
    props<{ dummyId:string, singleData: ClubManagement, files: CommunicationFile[], statuses: CommunicationStatus[], categories: CommunicationCategory[] }>()
);

export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record club management failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record club management',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record club management success'
);
export const addRecordFailure = createAction(
    '[Data] Add record club management failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record club management',
    props<{ id: string; isNew: boolean, updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record club management success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record club management failure',
    props<{ error: string }>()
);

//Update Status
export const updateRecordStatus = createAction(
    '[Data] Update record status club management',
    props<{ id: string; status: string }>()
);
export const updateRecordStatusSuccess = createAction(
    '[Data] Update record status club management success'
);
export const updateRecordStatusFailure = createAction(
    '[Data] Update record status club management failure',
    props<{ error: string }>()
);


// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record club management',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record club management success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record club management failure',
    props<{ error: string }>()
);

// Delete File
export const deleteFileRecord = createAction(
    '[Data] Delete record club file',
    props<{ taskId: string, id: string }>()
);
export const deleteFileRecordSuccess = createAction(
    '[Data] Delete record club file success'
);
export const deleteFileRecordFailure = createAction(
    '[Data] Delete record club file failure',
    props<{ error: string }>()
);


//Mark Read
export const markRead = createAction(
    '[Data] Mark task chat as read',
    props<{ id: string }>()
);

export const markReadSuccess = createAction(
    '[Data] Mark task chat as read success'
);

export const markReadFailure = createAction(
    '[Data] Mark task chat as read failure',
    props<{ error: string }>()
);


//Fetch Unread
export const fetchUnread = createAction(
    '[Data] Fetch task unread chat'
);

export const fetchUnreadSuccess = createAction(
    '[Data] Fetch task unread chat success'
);

export const fetchUnreadFailure = createAction(
    '[Data] Fetch task unread chat failure',
    props<{ error: string }>()
);


//Reset State
export const resetState = createAction(
    '[Data] reset state club management',
);